module.exports = __webpack_public_path__ + "static/img/isracard.8be958e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bank-logos/isracard.jpg
// module id = rd70
// module chunks = 6